import React, { useEffect, useState, useRef } from "react";

import "../../CSS/Style.css";

import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

import { Panel } from "primereact/panel";

import { MultiSelect } from "primereact/multiselect";

import { useTranslation } from "react-i18next";
import { TreeSelect } from "primereact/treeselect";
import MeasuresMetadataDialog from "../Others/MeasuresMetadataDialog";
import EventsMetadataDialog from "../Others/EventsMetadataDialog";
import EndProcessMetadataDialog from "../Others/EndProcessMetadataDialog";

import * as XLSX from "xlsx";
import { Dialog } from "primereact/dialog";
import { ToggleButton } from "primereact/togglebutton";
import AlarmsMetadataDialog from "../Others/AlarmsMetadataDialog";
import RunningMetadataDialog from "../Others/RunningMetadataDialog";
import ProfileDialog from "../Dialogs/ProfileDialog";
import { PROFILE_TYPES } from "../../Utility/Constants";
import LoadProfilesDialog from "../Dialogs/LoadProfilesDialog";
import dbManagerInterface from "../../Utility/DbConnection/DBManagerInterface";
import FiltersDialog from "../Dialogs/FiltersDialog";
import SPCDialog from "../Dialogs/SPCDialog";

const SearchPanelComponent = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  topNumber,
  setTopNumber,
  sampleTime,
  setSampleTime,
  selectedMachine,
  setSelectedMachine,
  selectedMeasures,
  setSelectedMeasures,
  measuresMetadata,
  setMeasuresMetadata,
  whereMeasures,
  setWhereMeasures,
  type,
  showGraph,
  setShowGraph,
  onSearchClick,
  idValue,
  setIdValue,
  tableData,
  onlyActive,
  setOnlyActive,
}) => {
  const { t } = useTranslation();

  //booleans to show single menu
  const [hasGraph, setHasGraph] = useState(false);
  const [hasRealtime, setHasRealtime] = useState(false);
  const [hasSampleTime, setHasSampleTime] = useState(false);
  const [hasMeasures, setHasMeasures] = useState(false);
  const [hasMultiple, setHasMultiple] = useState(false);
  const [hasMeasuresDialog, setHasMeasuresDialog] = useState(false);
  const [hasEventsDialog, setHasEventsDialog] = useState(false);
  const [hasAlarmsDialog, setHasAlarmsDialog] = useState(false);
  const [hasRunningDialog, setHasRunningDialog] = useState(false);
  const [hasEndProcessDialog, setHasEndProcessDialog] = useState(false);
  const [hasSpcDialog, setHasSpcDialog] = useState(false);
  const [hasDate, setHasDate] = useState(false);
  const [hasTop, setHasTop] = useState(false);
  const [hasMachine, setHasMachine] = useState(false);
  const [hasDropDown, setHasDropdown] = useState(false);
  const [hasRadioButtons, setHasRadioButtons] = useState(false);
  const [hasId, setHasId] = useState(false);
  const [hasOnlyActive, setHasOnlyActive] = useState(false);
  const [isRealtimeActive, setIsRealtimeActive] = useState(false);

  //data
  const [machines, setMachines] = useState([]);
  const [groupedMeasures, setGroupedMeasures] = useState([]);
  const [selectedMeasuresData, setSelectedMeasuresData] = useState({});
  const [profileType, setProfileType] = useState();

  //mode
  const [mode, setMode] = useState("single");

  //visibility
  const [measuresMetadataVisible, setMeasuresMetadataVisible] = useState(false);
  const [eventsMetadataVisible, setEventsMetadataVisible] = useState(false);
  const [alarmsMatadataVisible, setAlarmsMetadataVisible] = useState(false);
  const [runningMetadataVisible, setRunningMetadataVisible] = useState(false);
  const [endProcessMetadataVisible, setEndProcessMetadataVisible] =
    useState(false);
  const [filterDialogVisible, setFilterDialogVisible] = useState(false);
  const [profileDialogVisible, setProfileDialogVisible] = useState(false);
  const [spcVisible, setSpcVisible] = useState(false);
  const [loadProfileDialogVisible, setLoadProfileDialogVisible] =
    useState(false);

  const idText = type === "alarms" ? t("id") : t("idValue");

  useEffect(() => {
    if (measuresMetadataVisible) return;

    // Set initial start date and end date when the component mounts

    fetchData(type);
  }, [type, measuresMetadataVisible]);

  useEffect(() => {
    if (startDate == null && endDate == null) {
      const actualDate = new Date();
      setEndDate(actualDate);
      const actualDateMinusOneDay = new Date(
        actualDate.getTime() - 24 * 60 * 60 * 1000
      );
      setStartDate(actualDateMinusOneDay);
    } else {
      // ✅ FIX: use `new Date(...)` instead of `Date(...)`
      if (!(startDate instanceof Date)) setStartDate(new Date(startDate));
      if (!(endDate instanceof Date)) setEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  const fetchMachines = async (apiName) => {
    const client = sessionStorage.getItem("chosenClient");
    const plant = sessionStorage.getItem("chosenPlant");
    const queryParams = `Client=${client}-${plant}&Machine=null`;
    try {
      // Wrap the callback-based method into a Promise
      const resData = await new Promise((resolve, reject) => {
        dbManagerInterface.SendGetRequest(
          apiName,
          (resData) => resolve(resData), // Resolve on success
          (error) => reject(error), // Reject on error
          null,
          null,
          queryParams
        );
      });
      setMachines(resData.data);
      setSelectedMachine(resData.data);
      return resData.data;
    } catch (error) {
      console.error("Failed to fetch machines:", error);
      throw error; // Rethrow if needed
    }
  };

  const fetchMeasures = async (
    machines,
    apiName,
    preSelectEvents = false,
    hasMultiple
  ) => {
    try {
      const client = sessionStorage.getItem("chosenClient");
      const plant = sessionStorage.getItem("chosenPlant");
      const queryParams = `Client=${client}-${plant}&Machine=null`;
      dbManagerInterface.SendGetRequest(
        apiName,
        (results) => {
          if (results.success) {
            const data = results.data;
            console.log("data", data);

            setMeasuresMetadata(results.data);

            const groupedByMachine = data.reduce((acc, measure) => {
              const machine = measure.Machine;
              if (!acc[machine]) {
                acc[machine] = [];
              }
              acc[machine].push(measure);
              return acc;
            }, {});

            if (hasMultiple) {
              const groupedByMachineAndRunning = data.reduce((acc, measure) => {
                const machine = measure.Machine;
                const runningName = measure.RunningName;

                if (!acc[machine]) {
                  acc[machine] = {};
                }

                if (!acc[machine][runningName]) {
                  acc[machine][runningName] = [];
                }

                acc[machine][runningName].push(measure);

                return acc;
              }, {});

              const groupedMeasures = Object.entries(
                groupedByMachineAndRunning
              ).map(([machineKey, runningMeasures]) => ({
                key: machineKey,
                label: machineKey,
                children: Object.entries(runningMeasures).map(
                  ([runningName, measures]) => ({
                    key: `${machineKey}-${runningName}`,
                    label: runningName,
                    name: runningName,
                    machine: machineKey,
                    children: measures.map((measure) => ({
                      key: `${measure.Machine}-${measure.Name}`,
                      label: measure.Name,
                      name: measure.Name,
                      machine: measure.Machine,
                      id: measure.Id,
                    })),
                  })
                ),
              }));
              // Initialize selection state (all nodes checked)
              const initialSelectedMeasures = groupedMeasures.reduce(
                (acc, node) => {
                  acc[node.key] = { checked: true, partialChecked: false }; // Parent node
                  node.children.forEach((child) => {
                    acc[child.key] = {
                      checked: true,
                      partialChecked: false,
                      machine: child.machine,
                      name: child.name,
                    }; // Child nodes
                    child.children.forEach((grandChild) => {
                      acc[grandChild.key] = {
                        checked: true,
                        partialChecked: false,
                        machine: grandChild.machine,
                        name: grandChild.name,
                        id: grandChild.id,
                      };
                    });
                  });
                  return acc;
                },
                {}
              );
              setGroupedMeasures(groupedMeasures);
              if (preSelectEvents) {
                setSelectedMeasures(initialSelectedMeasures);
              }
              setSelectedMeasuresData(
                getSelectedMeasureNodes(
                  groupedMeasures,
                  initialSelectedMeasures
                )
              );
            } else {
              const groupedMeasures = Object.entries(groupedByMachine).map(
                ([machineKey, measures]) => {
                  const seenNames = new Set(); // to track unique names per machine

                  const uniqueMeasures = measures.filter((measure) => {
                    if (seenNames.has(measure.Name)) return false;
                    seenNames.add(measure.Name);
                    return true;
                  });

                  return {
                    key: machineKey,
                    label: machineKey,
                    children: uniqueMeasures.map((measure) => ({
                      key: `${measure.Machine}-${measure.Name}`,
                      label: measure.Name,
                      name: measure.Name,
                      machine: measure.Machine,
                      id: measure.Id,
                    })),
                  };
                }
              );

              // Initialize selection state (all nodes checked)
              const initialSelectedMeasures = groupedMeasures.reduce(
                (acc, node) => {
                  acc[node.key] = { checked: true, partialChecked: false }; // Parent node
                  node.children.forEach((child) => {
                    acc[child.key] = {
                      checked: true,
                      partialChecked: false,
                      machine: child.machine,
                      name: child.name,
                      id: child.id,
                    }; // Child nodes
                  });
                  return acc;
                },
                {}
              );
              setGroupedMeasures(groupedMeasures);
              if (preSelectEvents) {
                setSelectedMeasures(initialSelectedMeasures);
              }
              setSelectedMeasuresData(
                getSelectedMeasureNodes(
                  groupedMeasures,
                  initialSelectedMeasures
                )
              );
            }
          } else {
            console.error("Failed to fetch measures:", results);
          }
        },
        (error) => {
          console.error("error", error);
        },
        null,
        null,
        queryParams
      );
    } catch (error) {
      console.error("Failed to fetch measures:", error);
    }
  };

  const fetchMeasuresDescr = async (
    machines,
    apiName,
    preSelectEvents = false
  ) => {
    try {
      const client = sessionStorage.getItem("chosenClient");
      const plant = sessionStorage.getItem("chosenPlant");
      const queryParams = `Client=${client}-${plant}&Machine=null`;
      console.log("Fetching measures descr from API:", apiName);
      dbManagerInterface.SendGetRequest(
        apiName,
        (results) => {
          if (results.success) {
            setMeasuresMetadata(results.data);
          } else {
            console.error("Failed to fetch measures descr:", results);
          }
        },
        (error) => {
          console.error("error", error);
        },
        null,
        null,
        queryParams
      );
    } catch (error) {
      console.error("Failed to fetch measures:", error);
    }
  };

  const fetchData = async (type) => {
    console.log("Fetching data for type:", type);
    switch (type) {
      case "endprocess":
        setProfileType(PROFILE_TYPES.ENDPROCESS);
        setHasDate(true);
        setHasMeasures(true);
        setHasId(true);
        setHasMultiple(true);
        setHasEndProcessDialog(true);
        setHasSpcDialog(true);
        setMode("checkBox");
        const endProcessMac = await fetchMachines(
          "Automata/EndProcess/GetMachines"
        );
        await fetchMeasures(
          endProcessMac,
          "Automata/EndProcess/GetEndProcessMetadata",
          true,
          false
        );
        break;
      case "curves":
        setProfileType(PROFILE_TYPES.CURVES);
        setHasGraph(true);
        setHasDate(true);
        setHasMachine(false);
        setHasMeasures(true);
        setHasMultiple(true);
        setHasMeasuresDialog(true);
        setHasRadioButtons(true);
        setHasSpcDialog(true);
        setHasId(true);
        const curvesMac = await fetchMachines("Automata/Curves/GetMachines");
        await fetchMeasures(
          curvesMac,
          "Automata/Curves/GetCurvesMetadata",
          true,
          false
        );
        setMode("checkBox");
        break;

      case "alarms":
        setProfileType(PROFILE_TYPES.ALARMS);
        setHasDate(true);
        setHasMachine(true);
        setHasTop(true);
        setHasId(true);
        setHasAlarmsDialog(true);
        setHasOnlyActive(true);
        const alarmsMac = await fetchMachines("Automata/Alarms/GetMachines");
        await fetchMeasuresDescr(
          alarmsMac,
          "Automata/Alarms/GetAlarmsMetadata",
          false
        );
        break;
      case "event":
        setProfileType(PROFILE_TYPES.EVENTS);
        const eventMac = await fetchMachines("Automata/Events/GetMachines");
        await fetchMeasures(
          eventMac,
          "Automata/Events/GetEventsMetadata",
          false
        );
        await fetchMeasuresDescr(
          eventMac,
          "Automata/Events/GetEventsMetadataWithDescriptions",
          false
        );
        setHasDate(true);
        setHasMachine(false);
        setHasSampleTime(true);
        setHasTop(true);
        setHasDropdown(true);
        setHasEventsDialog(true);

        break;
      case "realtime":
        setProfileType(PROFILE_TYPES.CONTINUOUS);
        setHasGraph(true);
        setHasDate(true);
        setHasMachine(false); //useless, I have already the measures
        setHasSampleTime(true);
        setHasMeasures(true);
        setHasMeasuresDialog(true);
        setHasId(true);
        setHasTop(true);
        setHasMultiple(true);
        setMode("checkBox");
        setHasRadioButtons(true);
        setHasSpcDialog(true);
        setHasRealtime(true);
        const rtMac = await fetchMachines("Automata/RealTime/GetMachines");
        await fetchMeasures(
          rtMac,
          "Automata/RealTime/GetRealTimeMetadata",
          true,
          false
        );
        break;
      case "running":
        setProfileType(PROFILE_TYPES.RUNNING);
        setHasGraph(true);
        setHasDate(true);
        setHasMachine(false); //useless, I have already the measures
        setHasSampleTime(true);
        setHasMeasures(true);
        setHasMultiple(true);
        setHasRunningDialog(true);
        setHasId(false);
        setHasTop(true);
        setMode("checkBox");
        setHasRadioButtons(true);
        const runMac = await fetchMachines("Automata/Running/GetMachines");
        await fetchMeasures(
          runMac,
          "Automata/Running/GetRunningMetadata",
          true,
          true
        );
        break;
      default:
        setHasGraph(false);
        setHasSampleTime(false);
        setHasMeasuresDialog(false);
        setHasId(false);
        break;
    }
  };

  const intervalRef = useRef(null);

  function startRealtimeMeasuring() {
    if (intervalRef.current) return; // prevent multiple intervals

    setIsRealtimeActive(true);

    const measure = () => {
      const dateEnd = new Date();
      const dateStart = new Date(dateEnd.getTime() - 60 * 60 * 1000);

      setStartDate(dateStart);
      setEndDate(dateEnd);

      onSearchClick();

      console.log(
        `Measured from ${dateStart.toISOString()} to ${dateEnd.toISOString()}`
      );
    };

    // 🔥 Run immediately
    measure();

    // ⏱️ Then every 60 seconds
    intervalRef.current = setInterval(measure, 10 * 1000);

    console.log("Realtime measuring started.");
  }

  function stopRealtimeMeasuring() {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    setIsRealtimeActive(false);
    console.log("Realtime measuring stopped.");
  }

  const excelExport = (tableData, type) => {
    if (!tableData || tableData.length === 0) {
      console.error("No data available to export");
      return;
    }

    const filename =
      "export_" + type + "_" + new Date().toISOString().slice(0, 10) + ".xlsx";

    // 🧠 Detect all unique columns across all rows
    const headers = [...new Set(tableData.flatMap((row) => Object.keys(row)))];

    // 🔍 Type detection helper
    const parseValue = (value) => {
      if (value === null || value === undefined || value === "")
        return { v: "", t: "s" };

      // Already a Date
      if (value instanceof Date && !isNaN(value.getTime())) {
        return { v: value, t: "d", z: "yyyy-mm-dd hh:mm:ss" };
      }

      if (typeof value === "string") {
        const trimmed = value.trim();

        // Detect date or datetime string
        const dateRegex = /^\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2})?)?$/;
        if (dateRegex.test(trimmed)) {
          const normalized = trimmed.replace(" ", "T");
          const date = new Date(normalized);
          if (!isNaN(date.getTime())) {
            return { v: date, t: "d", z: "yyyy-mm-dd hh:mm:ss" };
          }
        }

        // Detect boolean
        const lower = trimmed.toLowerCase();
        if (lower === "true" || lower === "false") {
          return { v: lower === "true", t: "b" };
        }

        // Detect number
        if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
          const num = parseFloat(trimmed);
          const z = Number.isInteger(num) ? "0" : "0.00";
          return { v: num, t: "n", z };
        }

        return { v: value, t: "s" };
      }

      if (typeof value === "number" && !isNaN(value)) {
        const z = Number.isInteger(value) ? "0" : "0.00";
        return { v: value, t: "n", z };
      }

      return { v: String(value), t: "s" };
    };

    // 🧱 Build worksheet manually (header + data)
    const worksheet = {};

    // Header row
    headers.forEach((hdr, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
      worksheet[cellRef] = { v: hdr, t: "s" };
    });

    // Data rows
    tableData.forEach((row, rowIndex) => {
      headers.forEach((key, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 1,
          c: colIndex,
        });
        const value = row[key]; // may be undefined or missing
        worksheet[cellRef] = parseValue(value);
      });
    });

    // Define range (A1 → last column & row)
    const range = {
      s: { r: 0, c: 0 },
      e: { r: tableData.length, c: headers.length - 1 },
    };
    worksheet["!ref"] = XLSX.utils.encode_range(range);

    // Optional column width for readability
    worksheet["!cols"] = headers.map(() => ({ wch: 18 }));

    // Create workbook and sheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Export
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const ref = useRef(null);

  const getSelectedMeasureNodes = (tree, selectedKeys) => {
    const result = [];
    if (!tree || !selectedKeys) return result;

    const traverse = (nodes) => {
      for (let node of nodes) {
        if (selectedKeys[node.key]?.checked) {
          result.push(node); // or `node` if you want full tree node
        }
        if (node.children) {
          traverse(node.children);
        }
      }
    };
    traverse(tree);
    return result;
  };

  return (
    <Panel
      toggleable
      ref={ref}
      header={t("searchPanelTitle")}
      style={{
        width: "100%",
        backgroundColor: "#2b394f",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px", // Space between rows
          gap: "10px", // Space between child elements
          justifyContent: "center", // Space between child elements
          alignItems: "center", // Center items vertically
        }}
      >
        {/* Row 1 */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: "1 1 100%", // Ensures this occupies the full row
            gap: "20px",
            alignItems: "center",
          }}
        >
          {hasDate && (
            <>
              <label>{t("from")}</label>
              <Calendar
                value={startDate}
                onChange={(e) => setStartDate(e.value)}
                showTime
                selectionMode="single"
                showButtonBar
                showIcon
                dateFormat="dd/mm/yy"
              />
              <label>{t("to")}</label>
              <Calendar
                value={endDate}
                onChange={(e) => setEndDate(e.value)}
                showTime
                selectionMode="single"
                showButtonBar
                showIcon
                dateFormat="dd/mm/yy"
              />
            </>
          )}

          {hasMachine && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <label htmlFor="machines">{t("machine")} </label>
              <MultiSelect
                value={selectedMachine}
                onChange={(e) => setSelectedMachine(e.value)}
                options={machines}
                optionLabel="Machine"
                placeholder={t("machinePlaceholder")}
                className="w-full md:w-14rem"
                style={{ width: "200px" }}
              />
            </div>
          )}

          {hasMeasures && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <label htmlFor="measuresDialog">{t("measures")} </label>
              <TreeSelect
                filter
                id="measuresDialog"
                value={selectedMeasures}
                onChange={(e) => {
                  console.log("e.value", e.value);
                  const selectedData = getSelectedMeasureNodes(
                    groupedMeasures,
                    e.value
                  );
                  setSelectedMeasures(e.value);
                  setSelectedMeasuresData(selectedData);
                }}
                showClear
                options={groupedMeasures}
                metaKeySelection={false}
                selectionMode="checkbox"
                display="chip"
                placeholder={t("measuresPlaceholder")}
                style={{ height: "40px", width: "200px" }}
              />
            </div>
          )}
          {hasDropDown && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <label htmlFor="events">{t("event")} </label>
              <Dropdown
                id="measuresDialog"
                value={selectedMeasures}
                onChange={(e) => setSelectedMeasures(e.value)}
                options={groupedMeasures}
                metaKeySelection={true}
                selectionMode={mode}
                display="chip"
                placeholder={t("eventPlaceholder")}
                optionLabel="label"
                filter
                showClear
                optionGroupLabel="label"
                optionGroupChildren="children"
                style={{ height: "40px", width: "200px" }}
              ></Dropdown>
            </div>
          )}

          {hasMeasuresDialog && (
            <Button
              label={t("measuresDetails")}
              icon="pi pi-cog"
              onClick={() => setMeasuresMetadataVisible(true)}
              style={{ width: "250px" }}
            />
          )}

          {hasEventsDialog && (
            <Button
              label={t("measuresDetails")}
              icon="pi pi-cog"
              onClick={() => setEventsMetadataVisible(true)}
              style={{ width: "250px" }}
            />
          )}
          {hasAlarmsDialog && (
            <Button
              label={t("measuresDetails")}
              icon="pi pi-cog"
              onClick={() => setAlarmsMetadataVisible(true)}
              style={{ width: "250px" }}
            />
          )}
          {hasRunningDialog && (
            <Button
              label={t("measuresDetails")}
              icon="pi pi-cog"
              onClick={() => setRunningMetadataVisible(true)}
              style={{ width: "250px" }}
            />
          )}
          {hasEndProcessDialog && (
            <Button
              label={t("measuresDetails")}
              icon="pi pi-cog"
              onClick={() => setEndProcessMetadataVisible(true)}
              style={{ width: "250px" }}
            />
          )}
        </div>

        {/* Row 2 */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: "1 1 100%", // Ensures this occupies the full row
            gap: "20px",
            alignItems: "center",
          }}
        >
          {hasRealtime && (
            <ToggleButton
              checked={isRealtimeActive}
              onChange={(e) => {
                if (e.value) {
                  startRealtimeMeasuring();
                } else {
                  stopRealtimeMeasuring();
                }
              }}
              onLabel={t("realtime") + " " + "on"}
              offLabel={t("realtime") + " " + "off"}
              onIcon="pi pi-clock"
              offIcon="pi pi-clock"
              style={{ width: "200px" }}
            ></ToggleButton>
          )}
          {hasRadioButtons && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <ToggleButton
                checked={showGraph}
                onChange={(e) => setShowGraph(e.value)}
                offIcon={"pi pi-chart-bar"}
                onIcon={"pi pi-table"}
                offLabel={t("showGraph")}
                onLabel={t("showTable")}
              />
            </div>
          )}
          <Button
            label={t("saveProfile")}
            icon="pi pi-user"
            className="p-button"
            visible={false}
            onClick={() => {
              setProfileDialogVisible(true);
            }}
            style={{ width: "200px" }}
          ></Button>
          <Button
            label={t("loadProfile")}
            visible={false}
            icon="pi pi-download"
            onClick={() => setLoadProfileDialogVisible(true)}
            style={{ width: "200px" }}
          ></Button>
          <Button
            label={t("filters")}
            icon="pi pi-filter"
            style={{ width: "200px" }}
            onClick={() => setFilterDialogVisible(true)}
          />
          <Button
            label={t("export")}
            icon="pi pi-file-excel"
            onClick={() => {
              excelExport(tableData, type);
            }}
            style={{ width: "200px" }}
            className="p-button"
            disabled={
              tableData === undefined ||
              tableData == null ||
              tableData?.length === 0
            }
          />
          <Button
            label={t("spc")}
            icon="pi pi-chart-line"
            onClick={() => {
              setSpcVisible(true);
            }}
            style={{ width: "200px" }}
            className="p-button"
            disabled={
              tableData === undefined ||
              tableData == null ||
              tableData?.length === 0
            }
            visible={hasSpcDialog}
          ></Button>
          <Button
            label={t("search")}
            icon="pi pi-search"
            onClick={() => {
              onSearchClick();
              //ref.current.collapse();
            }}
            style={{ width: "200px" }}
          />
        </div>
      </div>
      {hasMeasuresDialog && (
        <MeasuresMetadataDialog
          measuresMetadata={measuresMetadata}
          visible={measuresMetadataVisible}
          type={type}
          onHide={() => setMeasuresMetadataVisible(false)}
        />
      )}
      {hasEventsDialog && (
        <EventsMetadataDialog
          measuresMetadata={measuresMetadata}
          visible={eventsMetadataVisible}
          onHide={() => setEventsMetadataVisible(false)}
        />
      )}
      {hasAlarmsDialog && (
        <AlarmsMetadataDialog
          measuresMetadata={measuresMetadata}
          visible={alarmsMatadataVisible}
          onHide={() => setAlarmsMetadataVisible(false)}
        />
      )}
      {hasRunningDialog && (
        <RunningMetadataDialog
          measuresMetadata={measuresMetadata}
          visible={runningMetadataVisible}
          onHide={() => setRunningMetadataVisible(false)}
        ></RunningMetadataDialog>
      )}
      {hasEndProcessDialog && (
        <EndProcessMetadataDialog
          measuresMetadata={measuresMetadata}
          visible={endProcessMetadataVisible}
          onHide={() => setEndProcessMetadataVisible(false)}
        ></EndProcessMetadataDialog>
      )}
      {hasMeasures && (
        <>
          {hasMeasures && (
            <ProfileDialog
              visible={profileDialogVisible}
              onHide={() => setProfileDialogVisible(false)}
              selectedMeasures={selectedMeasuresData}
              profileType={profileType}
            />
          )}

          <LoadProfilesDialog
            visible={loadProfileDialogVisible}
            onHide={() => setLoadProfileDialogVisible(false)}
            setSelectedMeasures={setSelectedMeasures}
            profileType={profileType}
          />
        </>
      )}
      {hasSpcDialog && (
        <SPCDialog
          visible={spcVisible}
          onHide={() => setSpcVisible(false)}
          chartData={tableData}
          measuresMetadata={measuresMetadata}
          storeType={"Realtime"}
        />
      )}

      <FiltersDialog
        visible={filterDialogVisible}
        onHide={() => setFilterDialogVisible(false)}
        type={type}
        idValue={idValue}
        setIdValue={setIdValue}
        sampleTime={sampleTime}
        setSampleTime={setSampleTime}
        topNumber={topNumber}
        setTopNumber={setTopNumber}
        onlyActive={onlyActive}
        setOnlyActive={setOnlyActive}
        hasId={hasId}
        hasSampleTime={hasSampleTime}
        hasTopNumber={hasTop}
        hasOnlyActive={hasOnlyActive}
        whereMeasures={whereMeasures}
        setWhereMeasures={setWhereMeasures}
      ></FiltersDialog>
    </Panel>
  );
};
export default SearchPanelComponent;
